import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import * as React from 'react';
export default {
  InlineCode,
  React
};